import gql from 'graphql-tag';

const UPDATE_STATUS_DEVICE = gql`
  mutation Mutation($deviceSerialNo: String!, $status: String!) {
    updateStatus(deviceSerialNo: $deviceSerialNo, status: $status) {
      code
    }
  }
`;

export default UPDATE_STATUS_DEVICE;
